<template>
  <article>
    <v-row justify="center" class="mt-4">
      <v-col>
        <p class="font-weight-light text-center subtitle pt-15">Case Study</p>
        <slot name="header"></slot>
        <p v-if="text != ``" class="artice-text text-center px-12">
          {{ text }}
        </p>
      </v-col>
    </v-row>

    <v-row class="mt-2 pa-16 pt-2">
      <v-col cols="12" s="12" xs="12" lg="6" xl="6" md="6">
        <slot name="image"></slot>
      </v-col>
      <v-col cols="12" s="12" xs="12" lg="6" xl="6" md="6">
        <v-card flat class="mt-4" :color="color">
          <v-card-title
            ><h5
              style="
                font-size: 1.5em;
                font-weight: 700 !important ;
                font-family: Poppins !important;
              "
            >
              Read the Case Study!
            </h5></v-card-title
          >
          <v-card-text style="font-size: 1.1em">{{
            caseStudyText
          }}</v-card-text>
          <v-card-actions class="pt-8 pl-4">
            <v-btn
              x-large
              tile
              class="rn-btn white--text pa-4"
              :href="link"
              target="blank"
              >READ NOW</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ital ma-16 pl-3 mt-0">
      <p class="text-justify">
        {{ say }}
      </p>
      <p class="text-justify">{{ dashedSay }}</p>
    </v-row>
  </article>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    color: {
      type: String,
    },
    caseStudyText: {
      type: String,
    },
    link: {
      type: String,
    },
    say: {
      type: String,
    },
    dashedSay: {
      type: String,
    },
  },
};
</script>


<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: $headerFontFamily;
}
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
}
.greyBG {
  background-color: $pgrey !important;
}
.rn-btn {
  background-color: $pred !important;
  transition: all 0.3s ease-out;

  &:hover {
    background-color: transparent !important;
    color: $pred !important;
    border: 2px solid $pred;
  }
}
.ital {
  border-left: 4px solid $pred;
  font-size: 1.1em;
  font-style: italic !important;
  font-family: $primaryFontFamily;
}
.subtitle {
  color: #616161;
  text-transform: capitalize;
  font-size: 16px;
  letter-spacing: 0.02em;
  line-height: 23px;
  font-family: Raleway !important;
  font-weight: 500;
}
</style>